import { GetPrivacyPolicy } from "../../../connection/privacy-policy";
import { Action, AsyncAction } from "../../../types/actions";

export const GET_PRIVACY_POLICY = 'GET_PRIVACY_POLICY';
export function getPrivacyPolicy(policy: number): AsyncAction {
	return {
		type: GET_PRIVACY_POLICY,
		promise: GetPrivacyPolicy(policy),
	};
}

export const CLEAR_PRIVACY_POLICY = 'CLEAR_PRIVACY_POLICY';
export function clearPrivacyPolicy(): Action {
	return {
		type: CLEAR_PRIVACY_POLICY,
		payload: null,
	};
}
